/*
 * Simple rich text editor
 * This component is a relatively simple wrapper over the Trix editor
 * It's best used for simple rich text, like image captions, that just need
 * newlines, bold, italic, underline.
 */

import React from "react";
import Trix from "trix";

import Cx from "classnames";
import styles from "./styles.scss";
import { instantSave } from "../../helpers.js";

export default class extends React.Component {
  onChange = () => {
    // throttle instant updates (wait 400ms)
    window.unsavedChanges(true);
    clearTimeout(window.editableChangeThrottle);
    window.editableChangeThrottle = setTimeout(() => {
      instantSave();
    }, 400);
  };

  onFocus = (e) => {
    e.target.classList.add(styles.active);
  };

  onBlur = (e) => {
    e.target.classList.remove(styles.active);
  };

  componentDidMount() {
    this.el.addEventListener("trix-focus", this.onFocus);
    this.el.addEventListener("trix-blur", this.onBlur);
    this.el.addEventListener("trix-change", this.onChange);
  }

  render() {
    return (
      <div className={Cx(styles.wrap, { [styles.html]: this.props.html })}>
        <input
          type="hidden"
          id={this.props.fieldId}
          name={this.props.fieldName}
          value={this.props.val}
        />
        <trix-editor
          input={this.props.fieldId}
          ref={(c) => {
            this.el = c;
          }}
        />
      </div>
    );
  }
}
